/* SPEEDFLY-LICENCE */
/* Speedfly V6 licence validator — boot / cache / validate / fail-open / status→behavior / overlay.
   Removable in one pass: grep SPEEDFLY-LICENCE. Contract: PROMPT-licence-v6-theme-SPEC.md §5–§8. */
(function () {
  var cfg = window.SpeedflyLicense;
  if (!cfg) return;

  var CACHE_KEY = 'sf_lic';
  var NEGATIVE_TTL_MS = 10 * 60 * 1000; // short re-check window for negative verdicts
  var TIMEOUT_MS = 6000;
  var STYLE_ID = 'sf-lic-style';
  var OVERLAY_ID = 'sf-lic-overlay';
  var BANNER_ID = 'sf-lic-banner';
  var NOTE_ID = 'sf-lic-note';
  var LOCK_CLASS = 'sf-lic-locked';

  var cachedVerdict = null; // the verdict read at boot — used by the fail-open catch

  // ---- cache helpers -------------------------------------------------------
  function readCache() {
    try {
      var raw = window.localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (o && typeof o === 'object' && typeof o.exp === 'number') return o;
    } catch (e) {}
    return null;
  }

  function writeCache(o) {
    try {
      window.localStorage.setItem(CACHE_KEY, JSON.stringify(o));
    } catch (e) {}
  }

  // ---- styles (injected once, only when something is shown) ----------------
  // C2: logical properties only. C3: colors via var(--color-*, #fallback).
  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      'html.' + LOCK_CLASS + '{overflow:hidden;}' +
      '#' + OVERLAY_ID + '{position:fixed;inset:0;z-index:2147483600;display:flex;' +
        'flex-direction:column;align-items:center;justify-content:center;' +
        'padding-block:48px;padding-inline:24px;text-align:center;' +
        'background:var(--color-background,#fff);color:var(--color-foreground,#0a0e1a);' +
        'font-family:inherit;line-height:1.5;}' +
      '#' + OVERLAY_ID + ' .sf-lic__box{max-inline-size:520px;}' +
      '#' + OVERLAY_ID + ' .sf-lic__title{font-size:1.5rem;font-weight:600;margin-block-end:12px;}' +
      '#' + OVERLAY_ID + ' .sf-lic__body{font-size:1rem;margin-block-end:8px;opacity:.85;}' +
      '#' + OVERLAY_ID + ' .sf-lic__secondary{font-size:.875rem;margin-block-end:8px;opacity:.7;}' +
      '#' + OVERLAY_ID + ' .sf-lic__cta{display:inline-block;margin-block-start:20px;' +
        'padding-block:12px;padding-inline:28px;border-radius:6px;text-decoration:none;font-weight:600;' +
        'background:var(--color-foreground,#0a0e1a);color:var(--color-background,#fff);}' +
      '#' + BANNER_ID + '{position:fixed;inset-block-start:0;inset-inline:0;z-index:2147483601;' +
        'padding-block:10px;padding-inline:16px;text-align:center;font-size:.875rem;' +
        'background:var(--color-foreground,#0a0e1a);color:var(--color-background,#fff);}' +
      '#' + NOTE_ID + '{position:fixed;inset-block-end:0;inset-inline:0;z-index:2147483601;' +
        'padding-block:8px;padding-inline:16px;text-align:center;font-size:.8125rem;' +
        'background:var(--color-background,#fff);color:var(--color-foreground,#0a0e1a);' +
        'border-block-start:1px solid var(--color-border,#e0e0e0);opacity:.9;}';
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function removeExisting() {
    [OVERLAY_ID, BANNER_ID, NOTE_ID].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    document.documentElement.classList.remove(LOCK_CLASS);
  }

  // ---- UI builders ---------------------------------------------------------
  // Full-screen, non-dismissable gate. Locks body scroll while shown.
  function injectOverlay(opts) {
    ensureStyle();
    var overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    var box = document.createElement('div');
    box.className = 'sf-lic__box';

    if (opts.title) {
      var h = document.createElement('div');
      h.className = 'sf-lic__title';
      h.textContent = opts.title;
      box.appendChild(h);
    }
    if (opts.body) {
      var p = document.createElement('div');
      p.className = 'sf-lic__body';
      p.textContent = opts.body;
      box.appendChild(p);
    }
    if (opts.secondary) {
      var s = document.createElement('div');
      s.className = 'sf-lic__secondary';
      s.textContent = opts.secondary;
      box.appendChild(s);
    }
    if (opts.ctaLabel && opts.ctaHref) {
      var a = document.createElement('a');
      a.className = 'sf-lic__cta';
      a.href = opts.ctaHref;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = opts.ctaLabel;
      box.appendChild(a);
    }

    overlay.appendChild(box);
    document.body.appendChild(overlay);
    document.documentElement.classList.add(LOCK_CLASS);
  }

  function injectBanner(message) {
    ensureStyle();
    var banner = document.createElement('div');
    banner.id = BANNER_ID;
    banner.setAttribute('role', 'status');
    banner.textContent = message;
    document.body.appendChild(banner);
  }

  function injectNote(message) {
    ensureStyle();
    var note = document.createElement('div');
    note.id = NOTE_ID;
    note.setAttribute('role', 'status');
    note.textContent = message;
    document.body.appendChild(note);
  }

  // ---- status → behavior (§7 matrix) --------------------------------------
  function applyState(s) {
    removeExisting();
    var t = cfg.strings || {};
    var design = cfg.designMode === true;
    var status = s && s.status;

    switch (status) {
      case 'active':
        return; // nothing

      case 'grace_period':
        // Store stays live. Banner is editor-only (covers the preview iframe).
        if (design) injectBanner((s && s.message) || t.graceFallback);
        return;

      case 'expired':
      case 'canceled':
      case 'suspended':
        // Kill-switch — the ONLY state that gates the live storefront (and editor).
        injectOverlay({
          title: t.expiredTitle,
          body: t.expiredBody,
          ctaLabel: t.expiredCta,
          ctaHref: cfg.billingUrl
        });
        return;

      case 'no_key':
        // Not activated yet — editor-only activate gate.
        if (design) injectOverlay({
          title: t.activateTitle,
          body: t.activateBody,
          ctaLabel: t.activateCta,
          ctaHref: cfg.billingUrl
        });
        return;

      case 'not_found':
      case 'invalid':
        // Editor-only (Decision #2: storefront NOT blocked). invalid appends server message.
        if (design) injectOverlay({
          title: t.invalidTitle,
          body: t.invalidBody,
          secondary: status === 'invalid' && s && s.message ? s.message : null
        });
        return;

      case 'max_stores_reached':
        // Editor-only (Decision #2).
        if (design) injectOverlay({
          title: t.maxTitle,
          body: t.maxBody
        });
        return;

      case 'unverified':
        // Network down + never validated — soft note only, never the hard gate.
        if (design) injectNote(t.networkNote);
        return;

      default:
        return;
    }
  }

  // ---- validate (§5) -------------------------------------------------------
  function validate(prevToken) {
    var body = {
      license_key: cfg.key,
      shop_domain: cfg.shop,
      theme: 'speedfly-v6'
    };
    if (prevToken) body.token = prevToken; // server short-circuits on a valid token

    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, TIMEOUT_MS);

    fetch(cfg.endpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit', // key travels in the body; no cookies needed (OPEN-ITEM #4)
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: controller.signal
    })
      .then(function (r) { return r.json(); }) // parse the body first — the verdict is authoritative regardless of HTTP status
      .then(function (data) {
        // A verdict must carry a boolean `valid` AND a string `status`; anything else
        // (500/HTML error page, unparseable/empty body) is a true failure → route to .catch.
        if (!data || typeof data.valid !== 'boolean' || typeof data.status !== 'string') {
          throw new Error('non-verdict response');
        }
        if (data.valid && data.token && data.token_expires_at) {
          writeCache({
            shop: cfg.shop,
            status: data.status,
            valid: true,
            token: data.token,
            exp: Date.parse(data.token_expires_at) // cache until this exact timestamp
          });
        } else {
          writeCache({
            shop: cfg.shop,
            status: data.status,
            valid: false,
            token: null,
            exp: Date.now() + NEGATIVE_TTL_MS
          });
        }
        applyState(data);
      })
      .catch(function () {
        // FAIL-OPEN: never NEWLY blank a live storefront on a network failure.
        if (cachedVerdict) {
          applyState({ status: cachedVerdict.status, valid: cachedVerdict.valid }); // honor last verdict
        } else {
          applyState({ status: 'unverified', valid: false }); // never validated + API down → no block
        }
      })
      .then(function () { window.clearTimeout(timer); });
  }

  // ---- boot (§6) -----------------------------------------------------------
  function boot() {
    if (!cfg.key) {
      applyState({ status: 'no_key', valid: false }); // no network call
      return;
    }
    cachedVerdict = readCache();
    if (cachedVerdict && cachedVerdict.shop === cfg.shop && Date.now() < cachedVerdict.exp) {
      applyState(cachedVerdict); // fresh cache → no call
      return;
    }
    validate(cachedVerdict && cachedVerdict.token); // stale/no cache → (re)validate
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
